/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};

  Shopify.theme.megaMenusTriggers = []

  Shopify.theme.jsMegaMenu = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section));

      // Selectors
      this.$header = $('#header')
      const parentLink = this.parent_link;
      const sectionId = this.section_id;
      const $megaMenu = $section.find('.mega-menu__' + sectionId);
      const $linkElement = $('.header__menu [data-navlink-handle="' + parentLink + '"]').attr('mega-menu-id', sectionId);
      // Remove old mega menus
      this.$header.append($megaMenu)
      if ($('.dropdown-click--false').length > 0) {
        $linkElement.on('mouseover', function () {
          Shopify.theme.jsMegaMenu.closeAll()
          Shopify.theme.jsMegaMenu.open($(this))
        })
      }
    },
    closeAll: function () {
      this.$header.find('.mega-menu__section').removeClass('is-active');
      this.$header.removeClass('mega-menu-active');
    },
    open: function (item) {
      const sectionId = item.attr('mega-menu-id');
      if (sectionId) {
        this.$header.find('.mega-menu__' + sectionId).addClass('is-active');
        this.$header.addClass('mega-menu-active');
      }else{
        this.closeAll()
      }
    },
    showThemeEditorState: function (id, $section) {
      console.log(id)
      this.$header.find('.mega-menu__' + id).addClass('mega-menu--force-show');
      this.$header.addClass('mega-menu-active');
    },
    hideThemeEditorState: function (id, $section) {
      this.$header.find('.mega-menu__' + id).removeClass('mega-menu--force-show');
      this.$header.removeClass('mega-menu-active');
    },
    unload: function ($section) {
      let parentLink = $section.find('.mega-menu').data('parent-link');
      let navLink = $('[data-navlink-handle="' + parentLink + '"]')
      navLink.off();
      navLink.find('.mega-menu__section').remove();
      $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
    }
  }

  /******/
})()
  ;